<template lang="pug">
  div.contact-us(@click.prevent="showCode = !showCode")
    img.contact(src="../assets/img/index/客服1.png")
    p 联系客服
    transition(name="move")
      img.code(src="../assets/img/index/qrcode.png" v-if="showCode")
</template>

<script>
export default {
  name: 'ContactUs',
  data () {
    return {
      showCode: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .contact-us{
    width: 66px;
    height: 66px;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 0 10px  rgba(0,0,0,0.1);
    position: fixed;
    right: 20px;
    bottom: 20px;
    text-align: center;
    cursor: pointer;
    img.contact{
      margin-top: 12px;
    }
    p{
      margin-top: 5px;
      color: #f87e5c;
      font-size: 12px;
    }
    img.code{
      width: 200px;
      height: 200px;
      position: absolute;
      left: -200px;
      top: -200px;
      box-shadow: 0 0 10px  rgba(0,0,0,0.1);
    }
    .move-enter-active, .move-leave-active {
      transition: transform .5s;
      transform:  scale(1);
      transform-origin: 100% 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
    .move-enter, .move-leave-to /* .fade-leave-active below version 2.1.8 */ {
      transform-origin: 100% 100%;
      transform: scale(0);
      position: absolute;
      left: 0;
      top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/ContactUs.vue